<ng-container *ngIf="chartData">
    <div class="chart-data-container">
        <p-chart
            #chartRef
            [type]="chartType"
            [data]="chartData"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            height="100%"
        ></p-chart>
    </div>

    <span *ngIf="noFocusData" class="message-container info-message">
        <span class="icon-container icon-container-info">i</span>
        <span translate>NO_DATA_FOR_SELECTED_DATE_RANGE</span>
    </span>
</ng-container>
